import request from '@/utils/request'

/**
 * 创建短信模板并提交大汉三通审核
 * @param {*} data
 * @returns
 */
export function createSmsTemplate(data) {
  return request({
    url: '/user/admin/sms/template/create',
    method: 'POST',
    data,
  })
}

/**
 * 获取短信模板列表
 * @param {*} data
 * @returns
 */
export function querySmsTemplateList(data) {
  return request({
    url: '/user/admin/sms/template/page',
    method: 'POST',
    data,
  })
}

/**
 * 账单统计：按月汇总发送量
 * @param {*} data
 * @returns
 */
export function querySmsBill(data) {
  return request({
    url: '/user/admin/sms/bill/page',
    method: 'POST',
    data,
  })
}

/**
 * 导出短信月度账单为 Excel
 * @param {*} data
 * @returns
 */
export function exportSmsBill(data) {
  return request({
    url: '/user/admin/sms/bill/export',
    method: 'POST',
    data,
  })
}

/**
 * 搜索当前企业下的会议/展会/论坛
 * @param {Object} params - { keyword }
 * @returns
 */
export function getSmsMeetings(params) {
  return request({
    url: '/user/admin/sms/users/meetings',
    method: 'GET',
    params,
  })
}

/**
 * 分页查询会议/展会参会者
 * @param {*} data
 * @returns
 */
export function getSmsUsers(data) {
  return request({
    url: '/user/admin/sms/users/page',
    method: 'POST',
    data,
  })
}

/**
 * 按筛选条件全量保存用户手机号到分组
 * @param {*} data
 * @returns
 */
export function saveUsersToGroup(data) {
  return request({
    url: '/user/admin/sms/users/saveToGroup',
    method: 'POST',
    data,
  })
}

/**
 * 创建手机号分组（平台用户/手动输入）
 * @param {*} data
 * @returns
 */
export function createPhoneGroup(data) {
  return request({
    url: '/user/admin/sms/phoneGroup/create',
    method: 'POST',
    data,
  })
}

/**
 * 发送短信（支持定时）
 * @param {*} data
 * @returns
 */
export function sendSms(data) {
  return request({
    url: '/user/admin/sms/send',
    method: 'POST',
    data,
  })
}

/**
 * Excel 导入手机号发送短信
 * @param {FormData} data - multipart/form-data，含 file, templateId, params, scheduleTime
 * @returns
 */
export function smsImportExcel(data) {
  return request({
    url: '/user/admin/sms/send/importExcel',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

/**
 * 分页查询短信发送记录
 * @param {*} data
 * @returns
 */
export function querySmsRecordPage(data) {
  return request({
    url: '/user/admin/sms/record/page',
    method: 'POST',
    data,
  })
}

/**
 * 导出短信发送记录为 Excel
 * @param {*} data
 * @returns
 */
export function exportSmsRecord(data) {
  return request({
    url: '/user/admin/sms/record/export',
    method: 'POST',
    data,
  })
}

/**
 * 批量取消短信定时发送
 * @param {number[]} ids - 发送记录 id 数组
 * @returns
 */
export function cancelScheduledSms(ids) {
  return request({
    url: '/user/admin/sms/record/cancelScheduled',
    method: 'POST',
    data: ids,
  })
}
